
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Prompt, Redirect } from 'react-router';
import { Button, Row, Col, ButtonToolbar, ButtonGroup, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown, Nav, NavItem, NavLink } from 'reactstrap';
import { Formik, Field, Form } from 'formik';
import DocumentTitle from 'react-document-title';
import classNames from 'classnames';
import LoadingIcon from 'mdi-react/LoadingIcon';
import CheckIcon from 'mdi-react/CheckIcon';
import DatePicker from '../../components/custom/DatePicker';
import NaviBar from '../../components/custom/NaviBar';
import DropdownField from '../../components/custom/DropdownField';
import AutoCompleteField from '../../components/custom/AutoCompleteField';
import RintagiScreen from '../../components/custom/Screen';
import ModalDialog from '../../components/custom/ModalDialog';
import { showNotification } from '../../redux/Notification';
import { registerBlocker, unregisterBlocker } from '../../helpers/navigation'
import { isEmptyId, getAddDtlPath, getAddMstPath, getEditDtlPath, getEditMstPath, getNaviPath, getDefaultPath, isEmailFormat, isNotEmpty } from '../../helpers/utils'
import { toMoney, toLocalAmountFormat, toLocalDateFormat, toDate, strFormat } from '../../helpers/formatter';
import { setTitle, setSpinner, setTopbarMenu, hideSidebar, hideTopbarMenu, registerTopbarLeft } from '../../redux/Global';
import { RememberCurrent, GetCurrent } from '../../redux/Persist'
import { getNaviBar } from './index';
import SubTestReduxObj from '../../redux/SubTest';
import Skeleton from 'react-skeleton-loader';
import ControlledPopover from '../../components/custom/ControlledPopover';
import log from '../../helpers/logger';
import { flushAccountInfo, loadPage, submitAccountInfo } from '../../redux/AccountInfo';
import VwRUsrSubDtlReduxObj, { ShowMstFilterApplied } from '../../redux/VwRUsrSubDtl';

class AccountSettings extends RintagiScreen {
  constructor(props) {
    super(props);

    this.state = {
      ScreenButton: null,
      initialing: true,
      Buttons: {},
      currentAccountInfo: {
        fullName: '',
        email: '',
        // country: '',
        // companyName: '',
        // orgSize: '',
      },
      key: Date.now(),
      ModalColor: "",
      ModalTitle: "",
      ModalHeader: false,
      ModalMsg: '',
      ModalOpen: false,
      ModalSuccess: null,
      submitting: false,
      isMobile: false,
    }

    this.GetReduxState = () => (this.props.VwRUsrSubDtl || {});
    this.blocker = null;
    this.titleSet = false;
    this.MstKeyColumnName = 'UsrSubsId4';
    this.SystemName = 'Rintagi';
    this.confirmUnload = this.confirmUnload.bind(this);
    this.hasChangedContent = false;
    this.setDirtyFlag = this.setDirtyFlag.bind(this);
    this.AutoCompleteFilterBy = (option, props) => { return true };
    this.OnModalReturn = this.OnModalReturn.bind(this);
    this.mobileView = window.matchMedia('(max-width: 1200px)');
    this.mediaqueryresponse = this.mediaqueryresponse.bind(this);

    this.props.setSpinner(true);

    this.props.registerTopbarLeft("","",true,"","");
    this.props.hideSidebar(false);
    this.props.hideTopbarMenu(false);

    // flushAccountInfo();

    Promise.all([
      this.props.loadPage(),
    ]).catch(error => {

    }).finally(() => {
      setTimeout(() => this.props.setSpinner(false), 500);
    })

    // this.props.setTopbarMenu(true);

    if (!this.props.suppressLoadPage && this.props.history) {
      RememberCurrent('LastAppUrl', (this.props.history || {}).location, true);
    }

    if (!this.props.suppressLoadPage) {
      this.props.setSpinner(true);
    }
  }

  mediaqueryresponse(value) {
    if (value.matches) { // if media query matches
      this.setState({ isMobile: true });
    }
    else {
      this.setState({ isMobile: false });
    }
  }

  subUsrId2InputChange() { const _this = this; return function (name, v) { const filterBy = ''; _this.props.SearchsubUsrId2(v, filterBy); } }/* ReactRule: Master Record Custom Function */
  /* ReactRule End: Master Record Custom Function */

  /* react related stuff */
  static getDerivedStateFromProps(nextProps, prevState) {
    // const nextReduxScreenState = nextProps.SubTest || {};
    // const buttons = nextReduxScreenState.Buttons || {};
    // const revisedButtonDef = super.GetScreenButtonDef(buttons, 'Mst', prevState);
    // const currentKey = nextReduxScreenState.key;
    // const waiting = nextReduxScreenState.page_saving || nextReduxScreenState.page_loading;
    // let revisedState = {};
    // if (revisedButtonDef) revisedState.Buttons = revisedButtonDef;

    // if (prevState.submitting && !waiting && nextReduxScreenState.submittedOn > prevState.submittedOn) {
    //   prevState.setSubmitting(false);
    // }

    // return revisedState;

    if (nextProps.accountInfo.initialized && nextProps.accountInfo.key >= prevState.key) {
      log.debug('im here');
      // redux initialized properly  
      return {
        initialing: false,
        currentAccountInfo: {
          ...((nextProps || {}).accountInfo || {}).currentAccountInfo,
        },
        key: Date.now(),
      }
    }
    else {
      log.debug('prop to state change', prevState.key, nextProps.accountInfo.key)
      return { key: nextProps.accountInfo.key }
    }
  }

  confirmUnload(message, callback) {
    const SubTestState = this.props.SubTest || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};
    const confirm = () => {
      callback(true);
    }
    const cancel = () => {
      callback(false);
    }
    this.setState({ ModalOpen: true, ModalSuccess: confirm, ModalCancel: cancel, ModalColor: 'danger', ModalTitle: auxSystemLabels.UnsavedPageTitle || '', ModalMsg: message });
  }

  setDirtyFlag(dirty) {
    /* this is called during rendering but has side-effect, undesirable but only way to pass formik dirty flag around */
    if (dirty) {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = this.confirmUnload;
      registerBlocker(this.confirmUnload);
    }
    else {
      if (this.blocker) unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    if (this.props.updateChangedState) this.props.updateChangedState(dirty);
    this.SetCurrentRecordState(dirty);
    return true;
  }

  countryInputChange() {
    const _this = this;
    return function () { };
    // return function (name, v) {
    //   _this.props.SearchincorporationCountry(v);
    // }
  }

  SubmitAccountInfo = (values, { setSubmitting }) => {
    this.IsFormSubmit = false;
    this.setState({ submittedOn: Date.now(), submitting: true, setSubmitting: setSubmitting });

    this.props.setSpinner(true);

    log.debug(this.FormAction);

    this.props.submitAccountInfo({
      ...values,
    }).then(() => {
      this.setState({ key: Date.now() });
    });
    // .then(() => {
    //   this.setState({ key: Date.now() })
    // });

    this.FormAction = undefined;
  }

  componentDidMount() {
    this.mediaqueryresponse(this.mobileView);
    this.mobileView.addListener(this.mediaqueryresponse) // attach listener function to listen in on state changes
    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    const suppressLoadPage = this.props.suppressLoadPage;
    if (!suppressLoadPage) {
      const { mstId } = { ...this.props.match.params };
      if (!(this.props.SubTest || {}).AuthCol || true) {
        this.props.LoadPage('Mst', { mstId: mstId || '_' });
      }
      if (!(this.props.VwRUsrSubDtl || {}).AuthCol || true) {
        this.props.LoadUserPage('SearchList', { mstId: '!' });
        this.props.LoadUserInitPage({ keyId: null });
      }
    }
    else {
      return;
    }
  }

  componentDidUpdate(prevProps, prevStates) {
    const currReduxScreenState = this.props.VwRUsrSubDtl || {};

    if (!this.props.suppressLoadPage) {
      if (!currReduxScreenState.page_loading && this.props.global.pageSpinner) {
        const _this = this;
        setTimeout(() => _this.props.setSpinner(false), 500);
      }
    }

    const currMst = currReduxScreenState.Mst || {};
    this.SetPageTitle(currReduxScreenState);
    if (prevStates.key !== currMst.key) {
      if ((prevStates.ScreenButton || {}).buttonType === 'SaveClose') {
        const currDtl = currReduxScreenState.EditDtl || {};
        const dtlList = (currReduxScreenState.DtlList || {}).data || [];
        const naviBar = getNaviBar('Mst', currMst, currDtl, currReduxScreenState.Label);
        const searchListPath = getDefaultPath(getNaviPath(naviBar, 'MstList', '/'))
        this.props.history.push(searchListPath);
      }
    }

    const currentReduxObj = this.props.accountInfo || {};
    const previousReduxObj = prevProps.accountInfo || {};
    const currentPayment = (currentReduxObj.currentPayment || {});
    const previousPayment = (previousReduxObj.currentPayment || {});

    // if (!currentReduxObj.loading && !trustProfileReduxObj.loading && !contactsReduxObj.loading && !this.state.submitting && this.props.global.pageSpinner && !this.redirecting) {
    //   const _this = this;
    //   setTimeout(() => _this.props.setSpinner(false), 500);
    // }
    if (this.state.submitting &&
      !(currentReduxObj.loading) &&
      ((previousReduxObj.key !== currentReduxObj.key) || currentReduxObj.status === "failed")
    ) {

      log.debug('##### 1');

      this.state.setSubmitting(false);
      if (currentReduxObj.status !== "failed") {
        log.debug('##### 2');
        // this.redirecting = true; // Control redirection
        this.props.showNotification('OK', { message: 'Account settings successfully saved' });
        setTimeout(() => { this.props.setSpinner(false) }, 0);
      }
      else {
        this.setState({ submitting: false });
        this.props.setSpinner(false);
      }
    }
  }

  componentWillUnmount() {
    if (this.blocker) {
      unregisterBlocker(this.blocker);
      this.blocker = null;
    }
    this.mobileView.removeListener(this.mediaqueryresponse);
  }


  render() {
    const SubTestState = this.props.SubTest || {};

    if (SubTestState.access_denied) {
      return <Redirect to='/error' />;
    }

    const screenHlp = SubTestState.ScreenHlp;

    // Labels
    const siteTitle = (this.props.global || {}).pageTitle || '';
    log.debug(siteTitle);
    const MasterRecTitle = ((screenHlp || {}).MasterRecTitle || '');
    const MasterRecSubtitle = ((screenHlp || {}).MasterRecSubtitle || '');

    const screenButtons = SubTestReduxObj.GetScreenButtons(SubTestState) || {};
    const itemList = SubTestState.Dtl || [];
    const auxLabels = SubTestState.Label || {};
    const auxSystemLabels = SubTestState.SystemLabel || {};

    const columnLabel = SubTestState.ColumnLabel || {};
    const authCol = this.GetAuthCol(SubTestState);
    const authRow = (SubTestState.AuthRow || [])[0] || {};
    const currMst = ((this.props.SubTest || {}).Mst || {});
    const currDtl = ((this.props.SubTest || {}).EditDtl || {});
    const naviBar = getNaviBar('Mst', currMst, currDtl, screenButtons).filter(v => ((v.type !== 'Dtl' && v.type !== 'DtlList') || currMst.subTestId2));
    const selectList = SubTestReduxObj.SearchListToSelectList(SubTestState);
    const selectedMst = (selectList || []).filter(v => v.isSelected)[0] || {};
    const subTestId2 = currMst.subTestId2;
    const subTestDesc2 = currMst.subTestDesc2;
    const subDate2 = currMst.subDate2;
    const subUsrId2List = SubTestReduxObj.ScreenDdlSelectors.subUsrId2(SubTestState);
    const subUsrId2 = currMst.subUsrId2;

    const { dropdownMenuButtonList, bottomButtonList, hasDropdownMenuButton, hasBottomButton, hasRowButton } = this.state.Buttons;
    const hasActableButtons = hasBottomButton || hasRowButton || hasDropdownMenuButton;

    const isMobileView = this.state.isMobile;
    const useMobileView = (isMobileView && !(this.props.user || {}).desktopView);
    /* ReactRule: Master Render */
    /* ReactRule End: Master Render */

    const userPlan = 'P';
    const countryList = [
      { key: '1', value: '1', label: 'Canada' },
      { key: '2', value: '2', label: 'United States' }
    ];

    const orgSizeList = [
      { key: '1', value: '1', label: 'Less than 20 employees' },
      { key: '2', value: '2', label: '21-100 employees' },
      { key: '3', value: '3', label: 'More than 100 employees' },
    ];

    const reduxObj = this.props.accountInfo || {};

    const userName = ((this.props.VwRUsrSubDtl || {}).Mst || {}).UsrName4;
    const userEmail = ((this.props.VwRUsrSubDtl || {}).Mst || {}).UsrEmail4;

    return (
      <DocumentTitle title={siteTitle}>
        <div>
          <ModalDialog color={this.state.ModalColor} title={this.state.ModalTitle} onChange={this.OnModalReturn} ModalOpen={this.state.ModalOpen} message={this.state.ModalMsg} />
          <div className='account'>
            <div className='account__wrapper account-left'>
              <div className='account__card'>
                <div>
                  <div className="account-narrow-left">
                    <div className='account__head mb-20'>
                      <h3 className='project-title mb-20'>Account Settings</h3>
                    </div>
                    <div className='w-100'>
                      <Row className="mb-10">
                        <Col>
                          <h4 className='account__title mb-20 fw-600'>Password</h4>
                          <Button
                            color="success"
                            type="button"
                            className="btn btn-success rounded account__btn mw-250"
                            onClick={() => { this.props.history.push('/change-password') }}>
                            Change Password</Button>
                        </Col>
                      </Row>
                      <Row className="mt-30">
                        <Col>
                          <h4 className='account__title fw-600'>Account Information</h4><br />
                        </Col>
                      </Row>
                      <h4 className='account__subhead subhead mb-20 fw-600'><i className="mdi mdi-account plan-id-icon color-rg-blue mr-10"></i>Name: <span className="uppercase">{userName}</span></h4>
                      <h4 className='account__subhead subhead mb-20 fw-600'><i className="mdi mdi-at plan-id-icon color-rg-blue mr-10"></i>Email: {userEmail}</h4>
                      {/* <Formik
                        initialValues={this.state.currentAccountInfo}
                        key={this.state.key}
                        validateOnChange={true}
                        validateOnBlur={true}
                        onSubmit={this.SubmitAccountInfo}
                        render={({
                          values,
                          errors,
                          touched,
                          isSubmitting,
                          dirty,
                          setFieldValue,
                          setFieldTouched,
                          handleChange,
                          submitForm,
                          setFieldError,
                        }) => (
                            <div>
                              {this.setDirtyFlag(dirty) &&
                                <Prompt
                                  when={dirty}
                                  message={auxSystemLabels.UnsavedPageMsg || ''}
                                />
                              }
                              <Form className='form'>
                                <div className='w-100'> */}
                                  {/* <Row>
                                    <Col sm={12} className="mb-15">
                                      <div className="payment-header">
                                        <p className='payment-header-type'>{planNameLong} Plan</p>
                                        <p className='payment-header-price'>{planCurrency} ${planPrice} {planPeriod && 'per ' + planPeriod}</p>
                                      </div>
                                    </Col>
                                  </Row>
                                  <p className="mb-20">Your account will be charged {planCurrency} ${toLocalAmountFormat(planPrice)} and will automatically renew every {planPeriod} unless cancelled. (You can cancel anytime.)</p>
                                  <h4 className='account__title fw-600 mb-10'>Credit Card Details</h4> */}
                                  {/* <div className='form__form-group'>
                                    <label className='form__form-group-label'>Full Name</label>
                                    <div className='form__form-group-field'>
                                      <Field
                                        type='text'
                                        name='fullName'
                                        validate={this.RequiredField({ setFieldValue, setFieldTouched, values, name: 'fullName', message: "Please enter full name" })}
                                        onChange={this.TextChange(setFieldValue, setFieldTouched, "fullName")}
                                        value={values.fullName}
                                      />
                                    </div>
                                    {errors.fullName && touched.fullName && <span className='form__form-group-error'>{errors.fullName}</span>}
                                  </div>
                                  <div className='form__form-group'>
                                    <label className='form__form-group-label'>Email</label>
                                    <div className='form__form-group-field'>
                                      <Field
                                        type="text"
                                        name="email"
                                        validate={this.PassAll({ setFieldValue, setFieldTouched, values, name: 'email', message: "Please enter email", validators: [isNotEmpty, isEmailFormat] })}
                                        value={values.email}
                                        onChange={this.TextChange(setFieldValue, setFieldTouched, "email")}
                                      />
                                    </div>
                                    {errors.email && touched.email && <span className='form__form-group-error'>{errors.email}</span>}
                                  </div> */}
                                  {/* <div className='form__form-group'>
                                    <label className='form__form-group-label'>Country</label>
                                    <div className='form__form-group-field'>
                                      <Field
                                        component={AutoCompleteField}
                                        name='country'
                                        validate={this.RequiredField({ setFieldValue, setFieldTouched, setFieldError, values, name: 'country', message: "Please select the country" })}
                                        onChange={this.AutocompleteChange(setFieldValue, setFieldTouched, "country")}
                                        onBlur={this.AutocompleteChange(setFieldValue, setFieldTouched, "country", true)}
                                        onInputChange={this.countryInputChange()}
                                        defaultSelected={this.BindAutocompleteField(values.country, countryList)}
                                        options={countryList}
                                      />
                                    </div>
                                    {errors.country && touched.country && <span className='form__form-group-error'>{errors.country}</span>}
                                  </div>
                                  <div className='form__form-group'>
                                    <label className='form__form-group-label'>Company Name</label>
                                    <div className='form__form-group-field'>
                                      <Field
                                        type='text'
                                        name='companyName'
                                        validate={this.RequiredField({ setFieldValue, setFieldTouched, values, name: 'companyName', message: "Please enter company name" })}
                                        onChange={this.TextChange(setFieldValue, setFieldTouched, "companyName")}
                                        value={values.companyName}
                                      />
                                    </div>
                                    {errors.companyName && touched.companyName && <span className='form__form-group-error'>{errors.companyName}</span>}
                                  </div>
                                  <div className='form__form-group'>
                                    <label className='form__form-group-label'>Organization Size</label>
                                    <div className='form__form-group-field'>
                                      <Field
                                        component={DropdownField}
                                        name='orgSize'
                                        validate={this.RequiredField({ setFieldValue, setFieldTouched, setFieldError, values, name: 'orgSize', message: "Please select organization size" })}
                                        onChange={this.DropdownChange(setFieldValue, setFieldTouched, "orgSize")}
                                        value={this.BindDropDownField(values.orgSize, orgSizeList, "orgSize")}
                                        options={orgSizeList}
                                      />
                                    </div>
                                    {errors.orgSize && touched.orgSize && <span className='form__form-group-error'>{errors.orgSize}</span>}
                                  </div> */}
                                  {/* <Row>
                                    <Col>
                                      <Button
                                        color="success"
                                        type='submit'
                                        disabled={isSubmitting || reduxObj.loading}
                                        className="btn btn-success rounded mw-flex-50 mt-10 account__btn"
                                        onClick={this.SubmitForm()}>Save Changes</Button>
                                    </Col>
                                  </Row> */}
                                {/* </div>
                              </Form>
                            </div>
                          )}
                      /> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    );
  };
};

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  error: state.error,
  SubTest: state.SubTest,
  global: state.global,
  accountInfo: state.accountInfo,
  plan: state.plan,
  VwRUsrSubDtl: state.VwRUsrSubDtl,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    { LoadPage: SubTestReduxObj.LoadPage.bind(SubTestReduxObj) },
    { LoadUserPage: VwRUsrSubDtlReduxObj.LoadPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadUserInitPage: VwRUsrSubDtlReduxObj.LoadInitPage.bind(VwRUsrSubDtlReduxObj) },
    { LoadSearchList: VwRUsrSubDtlReduxObj.LoadSearchList.bind(VwRUsrSubDtlReduxObj) },
    { SavePage: SubTestReduxObj.SavePage.bind(SubTestReduxObj) },
    { DelMst: SubTestReduxObj.DelMst.bind(SubTestReduxObj) },
    { AddMst: SubTestReduxObj.AddMst.bind(SubTestReduxObj) },
    //    { SearchMemberId64: SubTestReduxObj.SearchActions.SearchMemberId64.bind(SubTestReduxObj) },
    //    { SearchCurrencyId64: SubTestReduxObj.SearchActions.SearchCurrencyId64.bind(SubTestReduxObj) },
    //    { SearchCustomerJobId64: SubTestReduxObj.SearchActions.SearchCustomerJobId64.bind(SubTestReduxObj) },
    { SearchsubUsrId2: SubTestReduxObj.SearchActions.SearchsubUsrId2.bind(SubTestReduxObj) },
    { showNotification: showNotification },
    { setTitle: setTitle },
    { setSpinner: setSpinner },
    { setTopbarMenu: setTopbarMenu },
    { hideSidebar: hideSidebar },
    { hideTopbarMenu: hideTopbarMenu },
    { loadPage: loadPage },
    { submitAccountInfo: submitAccountInfo },
    { flushAccountInfo: flushAccountInfo },
    { registerTopbarLeft: registerTopbarLeft },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);




// WEBPACK FOOTER //
// ./src/pages/Custom/AccountSettings.js